<div class="vstack gap-3">
    <div class="vstack gap-2">
        <h5 class="fw-semibold m-0 px-3">
            Choose your booking duration
        </h5>
        @if (selectedSlotTime) {
            <h6 class="fw-medium m-0 px-3 text-muted">
                Select how long you'd like your table for at {{ selectedSlotTime | date : 'shortTime' }}.
            </h6>
        }
    </div>
    <div class="vstack gap-2">
        @if (hasAvailableDurations) {
            @for (option of durationOptions; track option.reason.id) {
                <app-reason-card
                    [reason]="option.reason"
                    [date]="selectedSlotTime!"
                    [isFull]="option.isUnavailable"
                    [disabledLabel]="'Unavailable for this time'"
                    [isSelected]="selectedDuration?.id === option.reason.id"
                    [attr.data-testid]="'duration-' + option.reason.displayName"
                    (reasonSelected)="onDurationSelected(option.reason, option.isUnavailable)"
                >
                </app-reason-card>
            }
        } @else {
            <app-no-availability
                [availability]="availability"
                [requiresDogFriendly]="form.get('requiresDogFriendly')?.value"
                [idealTime]="form.get('idealTime')?.value"
                [partySize]="form.get('partySize')?.value"
                [areaId]="form.get('selectedAreaId')?.value"
                [eventId]="form.get('selectedEventId')?.value"
                [reasonId]="form.get('selectedReasonId')?.value"
            >
            </app-no-availability>
        }
    </div>
    @if (hasAvailableDurations) {
        <div class="vstack gap-2">
            @if (showValidationError) {
                <div class="text-danger small px-3">
                    Please select a booking duration.
                </div>
            }
            <button
                class="btn btn-primary"
                type="button"
                (click)="next()"
                [disabled]="isLoading"
            >
                Next
            </button>
        </div>
    }
</div>